import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import momentTimezone from 'moment-timezone';
import moment from 'moment';

const TIMER_INTERVAL = 30000;

const timeDifference = (finishTime) => {
  const currentTime = momentTimezone();
  return momentTimezone(finishTime).diff(currentTime, 'minutes');
};

const StyledCountdownMessage = styled.div`
  ${props => props.theme.typography.subtitle2};
  color: ${props => props.theme.colors.text.secondary};
`;

const renderCountdownMessage = (remainingTime, finishTime) => {
  let message;
  if (remainingTime <= 0) {
    message = <StyledCountdownMessage>Time is up</StyledCountdownMessage>;
  } else if (remainingTime > 0 && remainingTime <= 60) {
    message = <StyledCountdownMessage>Selection window ends in {remainingTime}m</StyledCountdownMessage>;
  } else {
    const humanTimeToExpiry = moment(momentTimezone(finishTime)).calendar().toLowerCase();
    message = <StyledCountdownMessage>Selection window ends {humanTimeToExpiry}</StyledCountdownMessage>;
  }
  return message;
};

const SelectionCountdownTimer = ({ finishTime, onExpiry }) => {
  const [remainingTime, setRemainingTime] = useState(timeDifference(finishTime));

  useEffect(() => {
    const timer = setInterval(() => {
      const period = timeDifference(finishTime);

      if (period <= 0) {
        onExpiry();
      } else {
        setRemainingTime(period);
      }
    }, TIMER_INTERVAL);

    return () => {
      clearInterval(timer);
    };
  }, [finishTime]);

  return renderCountdownMessage(remainingTime, finishTime);
};

SelectionCountdownTimer.propTypes = {
  finishTime: PropTypes.string.isRequired,
  onExpiry: PropTypes.func,
};

SelectionCountdownTimer.defaultProps = {
  onExpiry: () => {},
};

export default SelectionCountdownTimer;
